// extracted by mini-css-extract-plugin
export var benefit = "Benefits_benefit__pghoH";
export var benefitsContainer = "Benefits_benefitsContainer__ApYDR";
export var description = "Benefits_description__VZAZd";
export var descriptionContainer = "Benefits_descriptionContainer__haH7l";
export var image = "Benefits_image__cUdaX";
export var legalReference = "Benefits_legalReference__A8phm";
export var lg = "992px";
export var logoBenefit = "Benefits_logoBenefit__SJ3D-";
export var md = "768px";
export var shared = "'../../../shared.module.css'";
export var xl = "1200px";